import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import { failureaddFalg, successaddFalg } from "./AddFalgSlice";
import { IFalg, IFalgList } from "../../../Pages/Yearlevel_map/IYearlevel_map";
import { failurelistFlag, successlistFlag } from "./ListFlagSlice";

// add
const AddFalgApi = (action: PayloadAction<IFalg>) => {
  return api.post("/api/exam/flag-question", action.payload);
};

export function* AddFalgCall(action: PayloadAction<IFalg>) {
  try {
    const response: AxiosResponse = yield call(AddFalgApi, action);
    yield put(successaddFalg(response.data));
  } catch (error) {
    yield put(failureaddFalg(error));
  }
}

// list instruction Falg
const ListFlagApi = (action: PayloadAction<IFalgList>) => {
  return api.get("/api/examflagged/get", { params: action.payload });
};

export function* ListFlagCall(action: PayloadAction<IFalgList>) {
  try {
    const response: AxiosResponse = yield call(ListFlagApi, action);
    yield put(successlistFlag(response.data));
  } catch (error) {
    yield put(failurelistFlag(error));
  }
}
